<div
    class="button-with-label"
    [ngClass]="{
    'reduced-style': reduced && !isTicketContext,
    'reduced-ticket-style': reduced && isTicketContext,
    'status-invert-ticket': isTicketContext && topic === 'status'
    }"
    >
    <span class="button-label">{{ label | translate }}</span>
    <button
        mat-icon-button
        [ngClass]="{
        'no-selection': status === 0,
        'in-progress': status === 1,
        selected: status === 2
        }"
        (click)="onDependentClick()"
        [disabled]="disabled"
        >
        <!-- no icon for what kind of thing this is, the colour says that; only
             a done status and a high priority carry one -->
        <mat-icon *ngIf="badge && status !== 1" class="badge" [style.color]="selectedColor"
                  >{{ badge }}</mat-icon
        >
        <ng-container *ngIf="status === 1">
            <mat-icon [style.color]="selectedColor" class="coloredcircle"
                      >hourglass_empty</mat-icon
            >
        </ng-container>
        <!-- a few letters more for the names that get cut, now that the icon
             no longer takes the room -->
        <ng-container *ngIf="showLabel">
            <p class="label">
                {{
        (topic === "branches" || topic === "departments") && selectedLabel.length > 12
          ? (selectedLabel | slice : 0 : 11) + "…"
          : selectedLabel
                }}
            </p>
        </ng-container>
    </button>
</div>
